// @flow
import type { PartialChatroomInfo } from '../Redux/ChatListActions';

export const parseRemoteChatroom = (chatroom: any): PartialChatroomInfo => ({
  id: chatroom.chatroom_id,
  name: chatroom.chatroom_name,
  description: chatroom.chatroom_description,
  chatroomType: chatroom.chatroom_type,
  managed: chatroom.managed || false,
  managerIds: chatroom.manager_ids || [],
  creatorId: chatroom.creator_id,
  memberCount: chatroom.member_count,
  doNotDisturb: chatroom.do_not_disturb,
  pinNumber: chatroom.pin_number,
  totalMessages: chatroom.total_message_count || 0,
  sentCount: chatroom.sent_count || 0,
  readCount: chatroom.read_count || 0,
  clearedCount: chatroom.cleared_count || 0,
  lastMessage: chatroom.last_instant_message_time
    ? {
        textContent: chatroom.last_instant_message_content ? chatroom.last_instant_message_content : 'File uploaded',
        sentTime: chatroom.last_instant_message_time,
      }
    : undefined,
  lastUpdateTime: chatroom.last_update_time,
  lastActiveTime: chatroom.last_active_time || null,
  donorId: chatroom.donor_id,
  organId: chatroom.organ_id,
  followerId: chatroom.follower_id || null,
  organType: chatroom.organ_type,
  targetOrgId: chatroom.transplant_center,
  createDate: chatroom.create_date,
  donorClosed: chatroom.donor_closed,
  caseName: chatroom.case_name,
  followerName: chatroom.follower_name,
  roomIcon: chatroom.room_icon || undefined,
});
